<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-4">
        <div class="bg-gray p-3 rounded">
          <div class="row">
            <div class="col-8 pr-0">
              <custom-dropdown
                v-model="academicYear"
                placeholder="Seleccione el año"
                fieldkey="id"
                fieldname="name"
                :options="academicYears"
              />
            </div>
            <div class="col">
              <action-button
                text="Buscar"
                variant="success w-100"
                i="fas fa-search"
                @click="getDisciplines"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="my-3">
      <div class="section-title">
        <div class="d-inline mr-2 bg-white">
          <i class="fas fa-folder-tree text-orange" />
        </div>
        <span class="color-gray-7 font-24 font-weight-bold">
          Documentos
        </span>
      </div>
    </div>
    <callout
      v-for="(discipline, index) in disciplines"
      :key="index"
      controlled
      has-toggle
      border-color="#f7f7f7"
      class="mb-2 custom-callout"
      :has-gradient="false"
      :opened="discipline.opened"
      @click:open="open(discipline)"
    >
      <div class="py-1">
        <div class="d-inline mr-2">
          <i class="fad fa-folder-open text-orange fa-lg-custom" />
        </div>
        <span class="color-gray-7 font-16 font-weight-bold">
          {{ discipline.name | empty }}
        </span>
      </div>
      <template #edition>
        <div class="mx-3 p-3">
          <custom-collapse id="disciplines-collapse">
            <custom-collapse-item
              v-for="(docType, key) in discipline.documentTypes"
              expanded-icon="fas fa-plus-circle custom-reorganize-btn"
              parent-id="disciplines-collapse"
              class="collapse-item mb-2 rounded"
              :id="`section-item-${key + 1}`"
              :key="`section-item-${key + 1}`"
              :ref="`section-item-${key + 1}`"
              :auto-expand-collapse-enabled="false"
              :keep-btn-visible="false"
              :expanded="docType.expanded"
              :title="docType.name"
              @expandButtonClick="expand(docType, discipline)"
            >
              <callout
                v-for="(doc, docKey) in docType.documents"
                :key="docKey"
                :has-toggle="false"
                :class="{ 'mt-3': docKey > 0 }"
                class="custom-callout-2"
              >
                <div class="row pt-1">
                  <div
                    class="col-12"
                    :class="{
                      'col-md-10': !doc.isPlan,
                      'col-md-4': doc.isPlan,
                    }"
                  >
                    <div class="data-title">Título:</div>
                    <p class="info-text">
                      {{ doc.name | empty }}
                    </p>
                  </div>
                  <div v-if="doc.isPlan" class="col-12 col-md">
                    <div class="data-title">Fecha de Plan:</div>
                    <p class="info-text">
                      {{ doc.planDate | date }}
                    </p>
                  </div>
                  <div v-if="doc.isPlan" class="col-12 col-md">
                    <div class="data-title">Hora:</div>
                    <p class="info-text">
                      {{ doc.planDate | hour }}
                    </p>
                  </div>
                  <div
                    class="col-12 col-md-2 px-0 mt-2 mt-md-0 d-flex justify-content-center"
                  >
                    <div class="align-self-center">
                      <action-button
                        text="Descargar"
                        variant="outline-success"
                        i="fas fa-file-download"
                        @click="
                          download(
                            doc.documentId,
                            doc.isAchievementSummary,
                            doc.isResultSummary,
                            doc.admissionId
                          )
                        "
                      />
                    </div>
                  </div>
                </div>
              </callout>
              <pagination
                v-if="
                  docType.pagination.totalItemCount >
                    docType.pagination.pageSize
                "
                :data="docType.pagination"
                :page-size="docType.pagination.pageSize"
                @pagination-go-page="
                  (page) => getDocuments(page, discipline, docType)
                "
              />
            </custom-collapse-item>
          </custom-collapse>
        </div>
      </template>
    </callout>
  </div>
</template>
<script>
import CustomDropdown from '@/components/common/CustomDropDown';
import { CustomCollapse, CustomCollapseItem } from '@/components/common';
import Callout from 'custom-callout';
import ActionButton from 'ActionButton';
import Pagination from 'pagination';

import generalService from '@/services/pei/general';

import {
  getRecordDisciplines,
  getRecordDisciplineDocumentTypes,
  getRecordDisciplineDocuments,
} from '@/modules/referral/api';

export default {
  components: {
    CustomDropdown,
    Callout,
    ActionButton,
    CustomCollapse,
    CustomCollapseItem,
    Pagination,
  },
  props: {
    academicYears: {
      type: Array,
      default: () => [],
    },
    referral: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    disciplines: [],
  }),
  async mounted() {
    await this.getDisciplines();
  },
  computed: {
    academicYear: {
      get() {
        return this.academicYears.find((x) => x.selected);
      },
      set(value) {
        this.academicYears.forEach((x) => (x.selected = x.id === value?.id));
      },
    },
    studentSie() {
      return this.referral?.studentSie;
    },
  },
  methods: {
    async open(item) {
      this.disciplines
        .filter((x) => x.id !== item.id)
        .forEach((x) => {
          x.opened = false;
          x.documentTypes.forEach((d) => (d.expanded = false));
        });
      item.opened = !item.opened;
      if (!item.documentTypes?.length) await this.getDocumentTypes(item);
      await this.expand(item.documentTypes[0], item);
    },
    async expand(item, discipline) {
      discipline.documentTypes
        .filter((x) => x.id !== item.id)
        .forEach((x) => (x.expanded = false));

      if (item.isAchievementSummary || item.isResultSummary) {
        item.documents = [
          {
            name: item.name,
            documentId: item.id,
            planDate: null,
            isPlan: false,
            isAchievementSummary: item.isAchievementSummary,
            isResultSummary: item.isResultSummary,
            admissionId: item.admissionId,
          },
        ];
      } else {
        discipline.documentTypes
          .filter((x) => x.id !== item.id)
          .forEach((x) => (x.expanded = false));

        if (!item.documents?.length)
          await this.getDocuments(1, discipline, item);
      }

      item.expanded = !item.expanded;
    },
    async getDisciplines() {
      if (!this.studentSie || !this.academicYear) return;
      const { data } = await getRecordDisciplines(
        this.studentSie,
        this.academicYear.id
      );
      this.disciplines = data.map((x) => ({
        ...x,
        opened: false,
        documentTypes: [],
      }));
      await this.setReferralDiscipline();
    },
    async getDocumentTypes(discipline) {
      if (!this.studentSie || !this.academicYear || !discipline) return;
      const { data } = await getRecordDisciplineDocumentTypes(
        this.studentSie,
        this.academicYear.id,
        discipline.id
      );
      discipline.documentTypes = data.map((x) => ({
        ...x,
        expanded: false,
        documents: [],
        pagination: {
          perPage: 5,
          currentPage: 1,
          totalItemCount: 0,
          pageCount: 0,
          count: 0,
        },
      }));
    },
    async getDocuments(page, discipline, docType) {
      if (!this.studentSie || !this.academicYear || !discipline || !docType)
        return;
      const query = {
        academicYearId: this.academicYear.id,
        disciplineTypeId: discipline.id,
        documentTypeId: docType.id,
        pageIndex: page,
        pageSize: 5,
      };
      const { data } = await getRecordDisciplineDocuments(
        this.studentSie,
        query
      );
      docType.documents = data.data;

      docType.pagination = {
        pageSize: query.pageSize,
        totalItemCount: data.totalItemCount,
        pageCount: data.pageCount,
        currentPage: data.currentPage,
        count: data.count,
      };
    },
    async download(id, isAchievementSummary, isResultSummary, admissionId) {
      if (isResultSummary) {
        let report = `referral/resultsummaryreport/${admissionId}/${id}`;
        await generalService.downloadReport(report);
        return;
      }
      if (isAchievementSummary) {
        let report = `referral/achievementssummaryreport/${admissionId}/${id}`;
        await generalService.downloadReport(report);
        return;
      }
      generalService.getDocument(id);
    },
    async setReferralDiscipline() {
      const { disciplineType: item } = this.referral;
      const discipline = this.disciplines.find((x) => x.id === item?.id);
      if (!discipline) return;
      this.disciplines = [...new Set([discipline, ...this.disciplines])];
      await this.open(discipline);
    },
  },
};
</script>
<style scoped lang="scss">
.section-title > div {
  border: 3px solid white;
  padding: 4px 8px;
  border-radius: 30px;
  -webkit-box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
}
.collapse-item ::v-deep .card-header {
  padding: 3px;
  background-color: white;
  border-radius: 5px;
}
.collapse-item ::v-deep .card-body {
  box-shadow: none;
  border-top: 2px solid #f7f7f7;
}

.fa-lg-custom {
  font-size: 1.7em;
  line-height: 0.75em;
  vertical-align: -0.0667em;
}
.custom-callout ::v-deep .col.p-2 {
  padding-left: 0 !important;
  margin-left: 8px !important;
}

.custom-callout ::v-deep .col.p-2 > .col-12 {
  border-left: 1px solid #e2e2e2;
}

.custom-callout-2 ::v-deep .col.p-2 > .col-12 {
  border-left: 0px solid #e2e2e2;
}
</style>
